import React, { useState } from "react";
import "./Sidebar.css";
import { Link } from "react-router-dom";
import BlogTour from "../Header/BlogTour";
import { CalendarCheck } from "lucide-react";
import assets from "../../assets/assets";

export default function Sidebar({
  footer,
  changeActiveMenuHome,
  changeActiveMenuHw,
  changeActiveMenuSummary,
  changeActiveMenuEngage,
  sidebarMenuHome,
  sidebarMenuW,
  sidebarMenuSummary,
  sidebarMenuEnggage,
}) {
  const Footer = localStorage.getItem("footerActive") || "Home";
  //hereadded logic for sidebar selection
  const getActiveMenuHome = () => localStorage.getItem("homeSideMenu") || "Dashboard";
  const getActiveMenuHw = () => localStorage.getItem("hwSideMenu");
  const getActiveMenuSummary = () => localStorage.getItem("summarySideMenu");
  const getActiveMenuEngage = () => localStorage.getItem("engageSideMenu");
  const activeMenuHome = getActiveMenuHome();
  const activeMenuHw = getActiveMenuHw();
  const activeMenuSummary = getActiveMenuSummary();
  const activeMenuEngage = getActiveMenuEngage();
  const [click, setClick] = useState(false)

  const handleClickHome = (newActiveMenu) => {
    changeActiveMenuHome(newActiveMenu);
    localStorage.setItem("ActiveHeader", newActiveMenu);
  };
  const handleClickHW = (newActiveMenu) => {
    changeActiveMenuHw(newActiveMenu);
  };
  const handleClickSummary = (newActiveMenu) => {
    changeActiveMenuSummary(newActiveMenu);
  };
  const handleClickEnggage = (newActiveMenu) => {
    changeActiveMenuEngage(newActiveMenu);
  };

  return (
    <div className="SidbarDetailContainer">
      <div className="d-flex justify-content-center ">
        <img src="/StudentImg/BreathSchoolLogo.png" alt="icon"></img>
      </div>

      {Footer === "Home" && (
        <div className="mt-4 featuredLeftPane">
          <Link to="/HomePage" className="link">
            <div
              style={{ cursor: "pointer" }}
              onClick={() => handleClickHome("Dashboard")}
            >
              <div className={activeMenuHome === "Dashboard" ? 'active-svg-icon' : 'svg-icon'}>
                {activeMenuHome === "Dashboard" ? (
                  <img src={assets.DashboaredActiveIcon} alt="icon"></img>
                ) : (
                  <img src={assets.DashboaredIcon} alt="icon"></img>
                )}
              </div>
              <div className="d-flex justify-content-center sidebarMenuText mt-2 "
                style={{
                  color: activeMenuHome === "Dashboard" ? "#F77F00" : "black",
                }}
              >
                Dashboard
              </div>
            </div>
          </Link>

          <Link to="/Library" className="link">
            <div
              style={{ cursor: "pointer" }}
              className="mt-4 library"
              onClick={() => handleClickHome("Library")}
            >
              <div className={activeMenuHome === "Library" ? 'active-svg-icon' : 'svg-icon'}>
                {activeMenuHome === "Library" ? (
                  <img src={assets.ContentLibraryActiveIcon} alt="icon"></img>
                ) : (
                  <img
                    src={assets.ContentLibraryIcon}
                    alt="icon"
                  ></img>
                )}
              </div>
              <div
                className="d-flex justify-content-center sidebarMenuText mt-2 "
                style={{
                  color: activeMenuHome === "Library" ? "#F77F00" : "black",
                }}
              >
                Library
              </div>
            </div>
          </Link>

          <Link to="/Calender" className="link">
            <div
              style={{ cursor: "pointer" }}
              className="mt-4 calender"
              onClick={() => { handleClickHome("Calender"); localStorage.setItem("From", "") }}
            >
              <div className={activeMenuHome === "Calender" ? 'active-svg-icon' : 'svg-icon'}>
                {activeMenuHome === "Calender" ? (
                  <img
                    src={assets.CalendarActiveIcon}
                    alt="icon"
                  ></img>
                ) : (
                  <img src={assets.CalendarIcon} alt="icon"></img>
                )}
              </div>
              <div
                className={
                  activeMenuHome === "Calender"
                    ? "d-flex justify-content-center sidebarMenuTextActive mt-2"
                    : "d-flex justify-content-center sidebarMenuText mt-2 "
                }
              >
                Calendar
              </div>
            </div>
          </Link>

          <Link to="/student-attendance" className="link">
            <div
              style={{ cursor: "pointer" }}
              // className=" mt-2 calender"
              className={
                activeMenuHome === "StudentAttendance" ? 'mt-4' : 'mt-4 calender'
              }
              onClick={() => { handleClickHome("StudentAttendance"); localStorage.setItem("From", "") }}
            >
              <div className={activeMenuHome === "StudentAttendance" ? 'active-svg-icon' : 'svg-icon'}>
                {activeMenuHome === "StudentAttendance" ? (
                  <img src={assets.AttendanceActiveIcon} alt="icon"></img>
                ) : (
                  <img src={assets.AttendanceIcon} alt="icon"></img>
                )}
              </div>
              <div
                className={
                  activeMenuHome === "StudentAttendance"
                    ? "d-flex justify-content-center sidebarMenuTextActive mt-2"
                    : "d-flex justify-content-center sidebarMenuText mt-2"
                }
              >
                Attendance
              </div>
            </div>
          </Link>
          <div>
            <div onClick={() => setClick(true)} style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", cursor: "pointer" }}>
              <img src="/images/blogIcon.png" alt="icon" style={{ width: "20px", marginTop: "25px", opacity: "0.8" }}></img>
              <div className="sidebarMenuText mt-3">Blog</div>
            </div>
          </div>
        </div>
      )}

      {Footer === "HMW" && (
        <div className="mt-4 featuredLeftPaneHWM">
          <Link to="/Homework" className="link">
            <div
              className="hw"
              style={{ cursor: "pointer" }}
              onClick={() => {
                handleClickHW("Homework");
                localStorage.setItem("hwSubMenu", "pending");
              }}
            >
              <div className="d-flex justify-content-center">
                {activeMenuHw === "Homework" ? (
                  <img src="/StudentImg/HomeworkActive.png" alt="icon"></img>
                ) : (
                  <img src="/StudentImg/homeWorkIcon.png" alt="icon"></img>
                )}
              </div>
              <div
                className="d-flex justify-content-center sidebarMenuText mt-2 "
                style={{
                  color: activeMenuHw === "Homework" ? "#F77F00" : "black",
                }}
              >
                Homework
              </div>
            </div>
          </Link>
          <Link to="/PreRead" className="link">
            <div
              style={{ cursor: "pointer" }}
              className="mt-4 pr"
              onClick={() => handleClickHW("Pre-read")}
            >
              <div className="d-flex justify-content-center ">
                {activeMenuHw === "Pre-read" ? (
                  <img src="/StudentImg/PreReadActive.png" alt="icon"></img>
                ) : (
                  <img src="/StudentImg/PreReadIcon.png" alt="icon"></img>
                )}
              </div>
              <div
                className="d-flex justify-content-center sidebarMenuText mt-2"
                style={{
                  color: activeMenuHw === "Pre-read" ? "#F77F00" : "black",
                }}
              >
                Pre-read
              </div>
            </div>
          </Link>
          <Link to="/Activity" className="link">
            <div
              style={{ cursor: "pointer" }}
              className="mt-4 pt-1 activity"
              onClick={() => {
                handleClickHW("Activity");
                localStorage.setItem("actSub", "pending");
              }}
            >
              <div className="d-flex justify-content-center ">
                {activeMenuHw === "Activity" ? (
                  <img src="/StudentImg/ActivityActive.png" alt="icon"></img>
                ) : (
                  <img src="/StudentImg/ActivityIcon.png" alt="icon"></img>
                )}
              </div>
              <div
                className="d-flex justify-content-center sidebarMenuText mt-2 "
                style={{
                  color: activeMenuHw === "Activity" ? "#F77F00" : "black",
                }}
              >
                Activity
              </div>
            </div>
          </Link>
        </div>
      )}

      {Footer === "DCM" && (
        <div className="mt-4 featuredLeftPaneDC ">
          <Link to="/Summary" className="link">
            <div
              className="summary"
              style={{ cursor: "pointer" }}
              onClick={() => handleClickSummary("Summary")}
            >
              <div className={activeMenuSummary === "Summary" ? 'active-svg-icon' : 'svg-icon'}>
                {activeMenuSummary === "Summary" ? (
                  <img src={assets.SummaryActiveIcon} alt="icon"></img>
                ) : (
                  <img src={assets.SummaryIcon} alt="icon"></img>
                )}
              </div>
              <div className="d-flex justify-content-center sidebarMenuText mt-2"
                style={{
                  color: activeMenuSummary === "Summary" ? "#F77F00" : "black",
                }}
              >
                Summary
              </div>
            </div>
          </Link>
          {/* <Link to='/Live' className='link'>
            <div style={{ cursor: 'pointer' }} onClick={() => handleClickSummary('LIVE')} >
              <div className='d-flex justify-content-center '>

                {activeMenuSummary=== 'LIVE' ?  <img src='/DCM-img/live_icon_active.svg' alt='icon'></img> : <img src='/DCM-img/LiveUnActive.png' alt='icon'></img> }

              </div>
              <div className='d-flex justify-content-center sidebarMenuText mt-2'>LIVE</div>
            </div>
          </Link> */}
          <Link to="/Assessment" className="link">
            <div
              style={{ cursor: "pointer" }}
              className="mt-4 pt-1 assessment"
              onClick={() => {
                handleClickSummary("Assessment");
                localStorage.setItem("assessSubMenu", "pending");
              }}
            >
              <div className={activeMenuSummary === "Assessment" ? 'active-svg-icon' : 'svg-icon'}>
                {activeMenuSummary === "Assessment" ? (
                  <img src={assets.AssessmentActiveIcon} alt="icon"></img>
                ) : (
                  <img src={assets.AssessmentIcon} alt="icon"></img>
                )}
              </div>
              <div
                className="d-flex justify-content-center sidebarMenuText mt-2 "
                style={{
                  color:
                    activeMenuSummary === "Assessment" ? "#F77F00" : "black",
                }}
              >
                Assessment
              </div>
            </div>
          </Link>

          <Link to="/SelfAssessment" className="link">
            <div
              style={{ cursor: "pointer" }}
              className="mt-4 pt-1 assessment"
              onClick={() => {
                handleClickSummary("SelfAssessment");
                localStorage.setItem("assessSubMenu", "pending");
              }}
            >
              <div className="d-flex justify-content-center ">
                {activeMenuSummary === "SelfAssessment" ? (
                  <img src="/DCM-img/AssesmentActive.png" alt="icon"></img>
                ) : (
                  <img src="/DCM-img/AssesmentUnActive.png" alt="icon"></img>
                )}
              </div>
              <div
                className="d-flex justify-content-center sidebarMenuText mt-2 align-items-center"
                style={{
                  color:
                    activeMenuSummary === "SelfAssessment" ? "#F77F00" : "black",
                }}
              >
                Self.Assessment
              </div>
            </div>
          </Link>
        </div>
      )}

      {Footer === "Engagement" && (
        <div className="mt-4 featuredLeftPaneE">
          <Link to="/EngagementCommunity" className="link">
            <div
              className="community"
              style={{ cursor: "pointer" }}
              onClick={() => handleClickEnggage("Community")}
            >
              <div className="d-flex justify-content-center ">
                {activeMenuEngage === "Community" ? (
                  <img
                    className="mt-2"
                    src="/Enggagement/communityActive.svg"
                    alt="icon"
                  ></img>
                ) : (
                  <img
                    className="mt-2"
                    src="/DCM-img/ComunityLogo.png"
                    alt="icon"
                  ></img>
                )}
              </div>
              <div
                className="d-flex justify-content-center sidebarMenuText mt-2 "
                style={{
                  color: activeMenuEngage === "Community" ? "#F77F00" : "black",
                }}
              >
                Community
              </div>
            </div>
          </Link>
          <Link to="/EngagementQuery" className="link">
            <div
              style={{ cursor: "pointer" }}
              className="mt-4  query"
              onClick={() => handleClickEnggage("Query")}
            >
              <div className="d-flex justify-content-center ">
                {activeMenuEngage === "Query" ? (
                  <img src="/Enggagement/QueryLogoActive.svg" alt="icon"></img>
                ) : (
                  <img src="/DCM-img/QueryLogo.png" alt="icon"></img>
                )}
              </div>
              <div
                className="d-flex justify-content-center sidebarMenuText mt-2"
                style={{
                  color: activeMenuEngage === "Query" ? "#F77F00" : "black",
                }}
              >
                Query
              </div>
            </div>
          </Link>
        </div>
      )}
      {
        click && <BlogTour setClick={setClick} />
      }
    </div>
  );
}
